<nb-card id="print-section-dept" class="print-layout">
  <nb-card-header>
    <h6 class="text-primary">
      Dữ liệu sao lưu nhà cung cấp - {{ supplier.fullName }}
    </h6>
    <div class="summary">
      <div>
        <ngx-view-time-period
          (periodChange)="selectTime($event)"
          [mode]="'dept'"
        ></ngx-view-time-period>

        <nb-checkbox
          [(ngModel)]="isDetail"
          [status]="isDetail ? 'danger' : 'primary'"
        >
          <span *ngIf="isDetail" class="text-primary link">Chi tiết</span>
          <span *ngIf="!isDetail" class="text-danger link">Tổng hợp</span>
        </nb-checkbox>
      </div>

      <ngx-card-value-overview
        [title]="'Doanh thu'"
        [value]="saleAmount"
        [type]="'info'"
        [icon]="'trending-up-outline'"
      >
      </ngx-card-value-overview>

      <ngx-card-value-overview
        [title]="'Thanh toán'"
        [value]="paidAmount"
        [type]="'success'"
        [icon]="'arrow-circle-up-outline'"
      >
      </ngx-card-value-overview>

      <ngx-card-value-overview
        [title]="'Còn nợ'"
        [value]="debitAmount"
        [type]="'warning'"
        [icon]="'alert-circle-outline'"
      >
      </ngx-card-value-overview>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Loại</th>
            <th scope="col">Số phiếu</th>
            <th scope="col">Ngày</th>
            <th *ngIf="isDetail" scope="col">Mô tả</th>
            <th scope="col">PS Tăng</th>
            <th scope="col">Đã thanh toán</th>
            <th scope="col">Còn nợ</th>
            <th scope="col">Ghi chú</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of displayDebits; let i = index">
            <td class="col-no">
              {{ i + 1 }}
            </td>
            <td>
              {{
                item.mode === "receipt"
                  ? "Bán hàng"
                  : item.mode === "purchase"
                  ? "Mua hàng"
                  : "Thanh toán"
              }}
            </td>
            <td>
              <a class="link text-link">
                <nb-icon icon="more-horizontal-outline"></nb-icon>
                {{ item.code }}
              </a>
            </td>
            <td>
              {{ item.issueDate | date : "dd/MM/yyyy" }}
            </td>

            <td *ngIf="isDetail">
              <div *ngIf="item.mode === 'payment'">
                <ul class="detail">
                  <li *ngIf="item.payment.personName">
                    <label class="label">
                      Người nhận:
                      <span class="text-body">
                        {{ item.payment.personName }}
                      </span>
                    </label>
                  </li>
                  <li *ngIf="item.payment.personMobile">
                    <label class="label">
                      ĐT:
                      <span class="text-body">
                        {{ item.payment.personMobile }}
                      </span>
                    </label>
                  </li>
                </ul>
              </div>
              <div *ngIf="item.mode === 'purchase'" class="table-responsive">
                <table class="table table-striped">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Tên hàng</th>
                      <th scope="col">ĐVT</th>
                      <th scope="col" class="col-number">Đơn giá</th>
                      <th scope="col" class="col-number">Số lượng</th>
                      <th scope="col" class="col-number">$ giảm</th>
                      <th scope="col" class="col-number">Thành tiền</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let itemDetail of item.purchase.purchaseDetails;
                        let i = index
                      "
                    >
                      <td class="col-no">
                        {{ i + 1 }}
                      </td>
                      <td>
                        {{ itemDetail.productName }}
                      </td>
                      <td>
                        {{ itemDetail.productUnitName }}
                      </td>
                      <td class="col-number">
                        {{ itemDetail.price | number }}
                      </td>
                      <td class="col-number">
                        {{ itemDetail.quantity | number }}
                      </td>
                      <td class="col-number">
                        {{ itemDetail.discountAmount | number }}
                      </td>
                      <td class="col-number">
                        <strong>{{ itemDetail.amount | number }}</strong>
                      </td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr>
                      <td class="col-label" colspan="4">
                        <strong class="text-hint">Tổng cộng</strong>
                      </td>
                      <td class="col-number">
                        <strong class="text-primary">
                          {{ item.purchase.totalQuantity | number }}
                        </strong>
                      </td>
                      <td></td>
                      <td class="col-number">
                        <strong class="text-primary">
                          {{ item.purchase.detailAmount | number }}
                        </strong>
                      </td>
                    </tr>

                    <tr *ngIf="item.purchase.discountAmount > 0">
                      <td class="col-label" colspan="4">
                        <strong class="text-hint">Chiết khấu</strong>
                      </td>
                      <td colspan="3" class="col-number">
                        <strong class="text-primary">
                          {{ item.purchase.discountAmount | number }}
                        </strong>
                      </td>
                    </tr>

                    <tr
                      *ngIf="
                        item.purchase.totalAmount !== item.purchase.detailAmount
                      "
                    >
                      <td class="col-label" colspan="4">
                        <strong class="text-hint">Thành tiền</strong>
                      </td>
                      <td colspan="3" class="col-number">
                        <strong class="text-primary">
                          {{ item.purchase.totalAmount | number }}
                        </strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </td>
            <td class="col-number">
              {{ item.amount | number }}
            </td>
            <td class="col-number">
              {{ item.paid | number }}
            </td>
            <td class="col-number">
              {{ item.debit | number }}
            </td>
            <td>
              {{ item.note }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      outline
      status="warning"
      size="small"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      In
    </button>

    <button
      nbButton
      outline
      status="info"
      size="small"
      (click)="exportAsXLSX()"
    >
      <nb-icon icon="download-outline"></nb-icon>
      {{ "buttons.downloadExcel" | translate }}
    </button>

    <button nbButton outline status="danger" size="small" (click)="close()">
      <nb-icon icon="close-outline"></nb-icon>
      <span>{{ "buttons.close" | translate }}</span>
    </button>
  </nb-card-footer>
</nb-card>
